import authApi from '@/app/api/authApi.ts';
import {
  MediationQueryType,
  type MediationResponse,
  type MediationsResponse,
} from '@/entities/mediation/api/types.ts';
import type { AxiosResponse } from 'axios';

export async function fetchMediations(
  queryParam?: MediationQueryType
): Promise<AxiosResponse<MediationsResponse>> {
  const url = queryParam ? `/mediations?${queryParam}` : '/mediations';
  return authApi({
    method: 'GET',
    url,
  });
}

export async function fetchMediation({
  mediationId,
}: {
  mediationId: number;
}): Promise<AxiosResponse<MediationResponse>> {
  return authApi({
    method: 'POST',
    url: `/mediation?mediation_id=${mediationId}`,
  });
}
